import script from "./CommissionRules.vue?vue&type=script&setup=true&lang=js"
export * from "./CommissionRules.vue?vue&type=script&setup=true&lang=js"

import "./CommissionRules.vue?vue&type=style&index=0&id=ae172534&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae172534"]])

export default __exports__